<template>
  <div
    class="d-flex pa-2 flex-column"
    :style="{
      'margin-bottom': '40px',
      width: '80%',
      'min-height': '550px',
      height: 'min-content',
    }"
  >
    <div class="d-flex pa-5 flex-column">
      <h3>Aggregator Registration</h3>
      <p>Silahkan lengkapi detail pendaftaran aggregator</p>
    </div>

    <v-card
      class="d-flex pa-2 flex-column"
      :style="{ margin: '20px' }"
      elevation="2"
    >
      <div style="padding: 10px">
        <v-row>
          <v-col cols="12">
            <v-autocomplete
              outlined
              id="qrType"
              ref="qrType"
              v-model="qrType"
              :items="listQrType"
              item-text="text"
              item-value="value"
              chips
              small-chips
              label="QR Type"
              multiple
              @change="$v.qrType.$touch()"
              @blur="$v.qrType.$touch()"
              :error-messages="qrTypeErrors"
            />
          </v-col>
          <v-col cols="12" v-show="stickerApiType">
            <v-radio-group class="ma-0" v-model="submerchantNotif" column>
              <template v-slot:label>
                <div>
                  Apakah anda membutuhkan <strong>notif transaksi</strong> via
                  API untuk merchant sticker anda?
                </div>
              </template>
              <v-radio label="Ya" value="1" />
              <v-radio label="Tidak" value="0" />
            </v-radio-group>
          </v-col>
          <v-col cols="12">
            <v-text-field
              outlined
              label="Nomor Rekening BNI *"
              id="noRekening"
              ref="noRekening"
              v-model="noRekening"
              @change="$v.noRekening.$touch()"
              @blur="$v.noRekening.$touch()"
              :error-messages="noRekeningErrors"
              :loading="isloadingRekening"
            />
          </v-col>
        </v-row>
      </div>
      <v-card
        class="mb-12"
        height="25px"
        :style="{ 'box-shadow': '0 0 black' }"
      >
        <div class="d-flex pa-5 flex-column align-center justify-center">
          <h3 class="mb-5">Data PIC</h3>
        </div>
      </v-card>
      <div style="padding: 10px">
        <v-row>
          <v-col cols="12">
            <v-text-field
              outlined
              label="Nama PIC *"
              id="PICName"
              ref="PICName"
              v-model="PICName"
              @change="$v.PICName.$touch()"
              @blur="$v.PICName.$touch()"
              :error-messages="PICNameErrors"
            />
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12">
            <v-text-field
              outlined
              label="Nomor KTP PIC *"
              v-model="noKTPPIC"
              id="noKTPPIC"
              ref="noKTPPIC"
              :counter="16"
              @change="$v.noKTPPIC.$touch()"
              @blur="$v.noKTPPIC.$touch()"
              :error-messages="noKTPPICErrors"
            />
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12">
            <v-text-field
              outlined
              label="Jabatan *"
              id="jabatan"
              ref="jabatan"
              v-model="jabatan"
              @change="$v.jabatan.$touch()"
              @blur="$v.jabatan.$touch()"
              :error-messages="jabatanErrors"
            />
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12">
            <v-text-field
              outlined
              label="Nomor Handphone *"
              id="noHandphone"
              ref="noHandphone"
              v-model="noHandphone"
              @change="$v.noHandphone.$touch()"
              @blur="$v.noHandphone.$touch()"
              :error-messages="noHandphoneErrors"
            />
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12">
            <v-text-field
              outlined
              label="Email *"
              id="emailPIC"
              ref="emailPIC"
              v-model="emailPIC"
              @change="$v.emailPIC.$touch()"
              @blur="$v.emailPIC.$touch()"
              :error-messages="emailPICErrors"
            />
          </v-col>
        </v-row>
      </div>
      <v-card
        class="mb-12"
        height="25px"
        :style="{ 'box-shadow': '0 0 black' }"
      >
        <div class="d-flex pa-5 flex-column align-center justify-center">
          <h3 class="mb-5">Data Aggregator</h3>
        </div>
      </v-card>
      <div style="padding: 10px">
        <v-row>
          <v-col cols="12">
            <v-text-field
              outlined
              label="Nama Perusahaan *"
              id="companyName"
              ref="companyName"
              v-model="companyName"
              @change="$v.companyName.$touch()"
              @blur="$v.companyName.$touch()"
              :error-messages="companyNameErrors"
            />
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="12">
            <v-text-field
              outlined
              label="Nama Pemilik Usaha *"
              id="aggregatorOwnerName"
              ref="aggregatorOwnerName"
              v-model="aggregatorOwnerName"
              @change="$v.aggregatorOwnerName.$touch()"
              @blur="$v.aggregatorOwnerName.$touch()"
              :error-messages="aggregatorOwnerNameErrors"
            />
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="12">
            <v-text-field
              outlined
              label="Nomor KTP Pemilik Usaha *"
              v-model="noKTP"
              id="noKTP"
              ref="noKTP"
              :counter="16"
              @change="$v.noKTP.$touch()"
              @blur="$v.noKTP.$touch()"
              :error-messages="noKTPErrors"
            />
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12">
            <v-text-field
              outlined
              label="Nomor NPWP Perusahaan *"
              v-model="noNPWP"
              id="noNPWP"
              ref="noNPWP"
              :counter="16"
              @change="$v.noNPWP.$touch()"
              @blur="$v.noNPWP.$touch()"
              :error-messages="noNPWPErrors"
            />
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12">
            <v-text-field
              outlined
              label="Email *"
              v-model="email"
              id="email"
              ref="email"
              @change="$v.email.$touch()"
              @blur="$v.email.$touch()"
              :error-messages="emailErrors"
            />
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" sm="3">
            <v-autocomplete
              clearable
              v-model="areaCode"
              id="areaCode"
              ref="areaCode"
              :items="itemsAreaCode"
              item-text="kode_area"
              item-value="kode_area"
              label="Area Code"
              :loading="isLoadingAreaCode"
              :search-input.sync="searchAreaCode"
              hide-selected
              outlined
            >
              <template v-slot:item="data">
                <template v-if="typeof data.item != 'object'">
                  <v-list-item-content>{{ data.item }}</v-list-item-content>
                </template>
                <template v-else>
                  <v-list-item-content>
                    <v-list-item-title>{{
                      data.item.kode_area
                    }}</v-list-item-title>
                    <v-list-item-subtitle>{{
                      data.item.wilayah
                    }}</v-list-item-subtitle>
                  </v-list-item-content>
                </template>
              </template>
            </v-autocomplete>
          </v-col>
          <v-col cols="12" sm="9">
            <v-text-field
              outlined
              id="noTelpAggregator"
              ref="noTelpAggregator"
              label="Nomor Telepon Perusahaan"
              @change="$v.noTelpAggregator.$touch()"
              @blur="$v.noTelpAggregator.$touch()"
              :error-messages="noTelpAggregatorErrors"
              v-model="noTelpAggregator"
            />
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12">
            <v-textarea
              outlined
              id="alamatAggregator"
              ref="alamatAggregator"
              label="Alamat Perusahaan *"
              v-model="alamatAggregator"
              @change="$v.alamatAggregator.$touch()"
              @blur="$v.alamatAggregator.$touch()"
              :error-messages="alamatAggregatorErrors"
            />
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12">
            <v-autocomplete
              clearable
              id="kodepos"
              ref="kodepos"
              v-model="kodepos"
              :items="itemsKodepos"
              return-object
              item-text="text"
              item-value="id"
              :error-messages="kodeposErrors"
              label="Kode Pos *"
              @change="$v.kodepos.$touch()"
              @blur="$v.kodepos.$touch()"
              :loading="isLoadingKodepos"
              :search-input.sync="searchKodepos"
              hide-selected
              outlined
            />
          </v-col>
        </v-row>
        <RegionalMappingFields
          :bcko.sync="bcko"
          :cmer.sync="cmer"
          :referralCode.sync="rmReferalCode"
          :itemsBcko="itemsBcko"
          :searchBcko.sync="searchBcko"
          :loadingBcko="isLoadingBcko"
          :itemsCmer="itemsCmer"
          :searchCmer.sync="searchCmer"
          :loadingCmer="isLoadingCmer"
          :bckoErrors="bckoErrors"
          :cmerErrors="cmerErrors"
          :referralCodeErrors="rmReferalCodeErrors"
          @touch-referral="$v.rmReferalCode.$touch()"
          @focus-bcko="onFocusBcko"
          @focus-cmer="onFocusCmer"
        />
      </div>
      <v-card
        class="mb-12"
        height="25px"
        :style="{ 'box-shadow': '0 0 black' }"
      >
        <div class="d-flex pa-5 flex-column align-center justify-center">
          <h3 class="mb-5">Endpoint</h3>
        </div>
      </v-card>
      <div style="padding: 10px">
        <v-row>
          <v-col cols="12">
            <v-text-field
              outlined
              label="URL"
              id="endpoint"
              ref="endpoint"
              v-model="endpoint"
              :error-messages="endpointErrors"
              @change="$v.endpoint.$touch()"
              @blur="$v.endpoint.$touch()"
            />
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12">
            <v-text-field
              outlined
              label="IP Address"
              id="ipaddress"
              ref="ipaddress"
              v-model="ipaddress"
              :error-messages="ipaddressErrors"
              @change="$v.ipaddress.$touch()"
              @blur="$v.ipaddress.$touch()"
            />
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12">
            <v-autocomplete
              id="IDApprover1"
              ref="IDApprover1"
              label="ID Approver 1 *"
              clearable
              v-model="IDApprover1"
              :items="itemsApprovalId1"
              item-id="id"
              item-text="username"
              return-object
              @change="$v.IDApprover1.$touch()"
              @blur="$v.IDApprover1.$touch()"
              :error-messages="IDApprover1Errors"
              :loading="isLoadingApprovalId1"
              :search-input.sync="searchApprovalId1"
              hide-selected
              outlined
            />
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12">
            <v-autocomplete
              id="IDApprover2"
              ref="IDApprover2"
              label="ID Approver 2 *"
              clearable
              v-model="IDApprover2"
              :items="itemsApprovalId2"
              item-id="id"
              item-text="username"
              return-object
              @change="$v.IDApprover2.$touch()"
              @blur="$v.IDApprover2.$touch()"
              :error-messages="IDApprover2Errors"
              :loading="isLoadingApprovalId2"
              :search-input.sync="searchApprovalId2"
              hide-selected
              outlined
            />
          </v-col>
        </v-row>

        <v-row class="pa-5">
          <v-btn
            small
            color="warning"
            :disabled="isLoading"
            :style="{ margin: '2px' }"
            @click="back"
            >Back
          </v-btn>
          <v-spacer />
          <v-btn
            small
            color="primary"
            :disabled="isLoading"
            :loading="isLoading"
            :style="{ margin: '2px' }"
            @click="save"
          >
            Save
          </v-btn>
        </v-row>
      </div>
    </v-card>
  </div>
</template>

<script>
import { validationMixin } from 'vuelidate';
import {
  required,
  email,
  numeric,
  maxLength,
  minLength,
  ipAddress,
  url,
} from 'vuelidate/lib/validators';
import RegionalMappingFields from '@/components/register/fields/RegionalMappingFields.vue';
import regionalMappingMixin from '@/components/inputer/aggregator/mixin';
import regionalMappingValidationMixin from '@/components/inputer/aggregator/validation';
import {
  dataListMerchantCriteria,
  validations,
  dataQrType,
  dataListIdApprover,
  scrollOptions,
  dataUserRoles,
  dataVarcharMaxLength,
  dataDelayServiceHit,
} from '../../../store/params';
import {
  date,
  regexAlphanumChar,
  regexDoesNotContainPipe,
} from '../../../lib/helpers';

export default {
  components: {
    RegionalMappingFields,
  },
  mixins: [validationMixin, regionalMappingMixin, regionalMappingValidationMixin],
  validations: {
    ...regionalMappingValidationMixin.validations,
    noRekening: {
      required,
      numeric,
      isUnique() {
        return (
          this.errorValidation != null &&
          (this.errorValidation.account_number == null ||
            this.errorValidation.account_number.length < 1)
        );
      },
    },
    noRekeningPerusahaan: { numeric },
    qrType: { required },
    PICName: {
      required,
      alphanumChar: regexAlphanumChar,
      maxLength: maxLength(dataVarcharMaxLength),
    },
    noKTPPIC: {
      required,
      numeric,
      maxLength: maxLength(16),
      minLength: minLength(16),
      isUnique() {
        return (
          this.errorValidation != null &&
          (this.errorValidation.aggre_pic_ktp_no == null ||
            this.errorValidation.aggre_pic_ktp_no.length < 1)
        );
      },
    },
    jabatan: {
      required,
      alphanumChar: regexAlphanumChar,
      maxLength: maxLength(dataVarcharMaxLength),
    },
    noHandphone: {
      required,
      numeric,
      maxLength: maxLength(15),
      isUnique() {
        return (
          this.errorValidation != null &&
          (this.errorValidation.aggre_pic_mobile_phone == null ||
            this.errorValidation.aggre_pic_mobile_phone.length < 1)
        );
      },
    },
    emailPIC: {
      required,
      email,
      doesNotContainPipe: regexDoesNotContainPipe,
      isUnique() {
        return (
          this.errorValidation != null &&
          (this.errorValidation.aggre_pic_email == null ||
            this.errorValidation.aggre_pic_email.length < 1)
        );
      },
    },
    companyName: {
      required,
      alphanumChar: regexAlphanumChar,
      maxLength: maxLength(dataVarcharMaxLength),
    },
    aggregatorOwnerName: {
      required,
      alphanumChar: regexAlphanumChar,
      maxLength: maxLength(dataVarcharMaxLength),
    },
    noKTP: {
      required,
      numeric,
      maxLength: maxLength(16),
      minLength: minLength(16),
      isUnique() {
        return (
          this.errorValidation != null &&
          (this.errorValidation.ktp_no == null ||
            this.errorValidation.ktp_no.length < 1)
        );
      },
    },

    noNPWP: {
      required,
      numeric,
      maxLength: maxLength(16),
      minLength: minLength(16),
      isUnique() {
        return (
          this.errorValidation != null &&
          (this.errorValidation.npwp_no == null ||
            this.errorValidation.npwp_no.length < 1)
        );
      },
    },
    email: {
      required,
      email,
      doesNotContainPipe: regexDoesNotContainPipe,
      isUnique() {
        return (
          this.errorValidation != null &&
          (this.errorValidation.email == null ||
            this.errorValidation.email.length < 1)
        );
      },
    },
    noTelpAggregator: { numeric, maxLength: maxLength(15) },
    alamatAggregator: {
      required,
      doesNotContainPipe: regexDoesNotContainPipe,
      maxLength: maxLength(dataVarcharMaxLength),
    },
    kodepos: { required },
    endpoint: { url, maxLength: maxLength(dataVarcharMaxLength) },
    ipaddress: { ipAddress, maxLength: maxLength(dataVarcharMaxLength) },
    IDApprover1: {
      required,
      isUnique() {
        return (
          this.errorValidation != null &&
          (this.errorValidation.approver_1 == null ||
            this.errorValidation.approver_1.length < 1)
        );
      },
    },
    IDApprover2: {
      required,
      isUnique() {
        return (
          this.errorValidation != null &&
          (this.errorValidation.approver_2 == null ||
            this.errorValidation.approver_2.length < 1)
        );
      },
    },
  },
  data() {
    return {
      done: false,
      pdfFileSK: 'dummy-1.pdf',
      isLoadingKodepos: false,
      isLoadingJenisUsaha: false,
      isLoadingAreaCode: false,
      isLoadingApprovalId1: false,
      isLoadingApprovalId2: false,
      searchApprovalId1: '',
      searchApprovalId2: '',
      logoAggregator: null,
      listCriteria: dataListMerchantCriteria,
      listIDApprover: dataListIdApprover,
      listQrType: dataQrType,
      listUserRoles: dataUserRoles,
      kodepos: null,
      areaCode: null,
      companyName: '',
      PICName: '',
      jabatan: '',
      aggregatorOwnerName: '',
      noKTP: '',
      noKTPPIC: '',
      noNPWP: '',
      email: '',
      emailPIC: '',
      noHandphone: '',
      noRekening: '',
      noRekeningPerusahaan: '',
      noTelpAggregator: '',
      alamatAggregator: '',
      searchKodepos: '',
      searchJenisUsaha: '',
      searchAreaCode: '',
      allFile: [],
      isHaveQRIS: '0',
      validate: validations,
      ktpFileFocus: 0,
      npwpFileFocus: 0,
      fotoAggregatorFileFocus: 0,
      IDApprover1: null,
      IDApprover2: null,
      endpoint: null,
      ipaddress: null,
      qrType: [],
      submerchantNotif: '0',
      delayHitServiceA1: null,
      delayHitServiceA2: null,
      isloadingRekening: false,
    };
  },
  mounted() {
    this.getApprovalId1(this.listUserRoles[0].value);
    this.getApprovalId2(this.listUserRoles[1].value);

    this.getAreaCode();
  },
  watch: {
    searchKodepos: {
      handler() {
        this.getDaerah();
      },
    },
    noRekening: {
      handler(val) {
        this.getValidateRek(val);

        if (this.errorValidation != null) {
          if (
            this.errorValidation.account_number != null &&
            val != this.errorValidation.account_number
          ) {
            this.$store.commit(
              'inputer/aggregator/clearErrorVariable',
              'account_number'
            );
          }
        }
      },
    },
    noKTPPIC: {
      handler(val) {
        if (this.errorValidation != null) {
          if (
            this.errorValidation.aggre_pic_ktp_no != null &&
            val != this.errorValidation.aggre_pic_ktp_no
          ) {
            this.$store.commit(
              'inputer/aggregator/clearErrorVariable',
              'aggre_pic_ktp_no'
            );
          }
        }
      },
    },
    emailPIC: {
      handler(val) {
        if (this.errorValidation != null) {
          if (
            this.errorValidation.aggre_pic_email != null &&
            val != this.errorValidation.aggre_pic_email
          ) {
            this.$store.commit(
              'inputer/aggregator/clearErrorVariable',
              'aggre_pic_email'
            );
          }
        }
      },
    },
    email: {
      handler(val) {
        if (this.errorValidation != null) {
          if (
            this.errorValidation.email != null &&
            val != this.errorValidation.email
          ) {
            this.$store.commit(
              'inputer/aggregator/clearErrorVariable',
              'email'
            );
          }
        }
      },
    },
    noKTP: {
      handler(val) {
        if (this.errorValidation != null) {
          if (
            this.errorValidation.ktp_no != null &&
            val != this.errorValidation.ktp_no
          ) {
            this.$store.commit(
              'inputer/aggregator/clearErrorVariable',
              'ktp_no'
            );
          }
        }
      },
    },
    noNPWP: {
      handler(val) {
        if (this.errorValidation != null) {
          if (
            this.errorValidation.npwp_no != null &&
            val != this.errorValidation.npwp_no
          ) {
            this.$store.commit(
              'inputer/aggregator/clearErrorVariable',
              'npwp_no'
            );
          }
          if (val.length === 15 && !val.startsWith('0')) {
            this.noNPWP = `0${val}`;
          }
        }
      },
      immediate: true,
    },
    noHandphone: {
      handler(val) {
        if (this.errorValidation != null) {
          if (
            this.errorValidation.aggre_pic_mobile_phone != null &&
            val != this.errorValidation.aggre_pic_mobile_phone
          ) {
            this.$store.commit(
              'inputer/aggregator/clearErrorVariable',
              'aggre_pic_mobile_phone'
            );
          }
        }
      },
    },
    searchApprovalId1: {
      handler() {
        clearTimeout(this.delayHitServiceA1);
        this.delayHitServiceA1 = setTimeout(() => {
          this.getApprovalId1(this.listUserRoles[0].value);
        }, dataDelayServiceHit);
      },
    },
    searchApprovalId2: {
      handler() {
        clearTimeout(this.delayHitServiceA2);
        this.delayHitServiceA2 = setTimeout(() => {
          this.getApprovalId2(this.listUserRoles[1].value);
        }, dataDelayServiceHit);
      },
    },
    IDApprover1: {
      handler(val, oldVal) {
        if (val !== oldVal && this.errorValidation?.approver_1?.length > 0) {
          this.$store.commit(
            'inputer/aggregator/clearErrorVariable',
            'approver_1'
          );
        }
      },
      deep: true,
    },
    IDApprover2: {
      handler(val, oldVal) {
        if (val !== oldVal && this.errorValidation?.approver_2?.length > 0) {
          this.$store.commit(
            'inputer/aggregator/clearErrorVariable',
            'approver_2'
          );
        }
      },
      deep: true,
    },
  },
  computed: {
    itemsApprovalId1() {
      const list = this.$store.state.master.daerah.list.approvalId1.find(
        (a) =>
          a.user_id ==
          JSON.parse(localStorage.getItem('logged_in_qram')).user.id
      );
      return list != undefined
        ? [list]
        : this.$store.state.master.daerah.list.approvalId1;
    },
    itemsApprovalId2() {
      return this.$store.state.master.daerah.list.approvalId2;
    },
    errorValidation() {
      return this.$store.state.inputer.aggregator.errors;
    },
    /**
     * Whether the last submission was rejected because of specific fields.
     *
     * Only a field-level rejection warrants scrolling to an input. A denied
     * permission, an expired session or a server fault leaves every field
     * valid, so scrolling would send the user hunting for an error that is not
     * there.
     *
     * @returns {boolean} True when at least one field carries an error.
     */
    hasFieldErrors() {
      const errors = this.errorValidation;
      if (errors == null || typeof errors !== 'object') return false;

      return Object.keys(errors).some(
        (field) => (errors[field] || []).length > 0
      );
    },
    aggregatorPhone() {
      const area = this.areaCode != null ? `(${this.areaCode})` : '';
      const phone = this.noTelpAggregator != '' ? this.noTelpAggregator : '';
      return `${area} ${phone}`;
    },
    stickerApiType() {
      return (
        this.qrType.find((val) => val == 1) &&
        this.qrType.find((val) => val == 2)
      );
    },
    noRekeningErrors() {
      const errors = [];
      if (!this.$v.noRekening.$dirty) return errors;
      if (!this.$v.noRekening.required)
        errors.push('Nomor Rekening is required');
      if (!this.$v.noRekening.numeric) errors.push('Must be numeric');
      if (!this.$v.noRekening.isUnique) {
        if (this.errorValidation.account_number != null) {
          this.errorValidation.account_number.forEach((item) => {
            errors.push(item);
          });
        }
      }
      return errors;
    },
    noRekeningPerusahaanErrors() {
      const errors = [];
      if (!this.$v.noRekeningPerusahaan.$dirty) return errors;
      if (!this.$v.noRekeningPerusahaan.required)
        errors.push('Nomor Rekening Perusahaan is required');
      if (!this.$v.noRekeningPerusahaan.numeric) errors.push('Must be numeric');
      return errors;
    },
    qrTypeErrors() {
      const errors = [];
      if (!this.$v.qrType.$dirty) return errors;
      if (!this.$v.qrType.required) errors.push('QR Type is required');
      return errors;
    },
    kodeposErrors() {
      const errors = [];
      if (!this.$v.kodepos.$dirty) return errors;
      if (!this.$v.kodepos.required) errors.push('Kode Pos is required');
      return errors;
    },
    jenisUsahaErrors() {
      const errors = [];
      if (!this.$v.jenisUsaha.$dirty) return errors;
      if (!this.$v.jenisUsaha.required) errors.push('Jenis Usaha is required');
      return errors;
    },
    aggregatorCriteriaErrors() {
      const errors = [];
      if (!this.$v.aggregatorCriteria.$dirty) return errors;
      if (!this.$v.aggregatorCriteria.required)
        errors.push('Aggregator Criteria is required');
      return errors;
    },
    companyNameErrors() {
      const errors = [];
      if (!this.$v.companyName.$dirty) return errors;
      if (!this.$v.companyName.required)
        errors.push('Nama Perusahaan is required');
      if (!this.$v.companyName.maxLength)
        errors.push(
          `Company name can't more than ${dataVarcharMaxLength} character`
        );
      if (!this.$v.companyName.alphanumChar)
        errors.push(`Valid character are A-z, 0-9, and (*)`);
      return errors;
    },
    PICNameErrors() {
      const errors = [];
      if (!this.$v.PICName.$dirty) return errors;
      if (!this.$v.PICName.required) errors.push('Nama Aggregator is required');
      if (!this.$v.PICName.maxLength)
        errors.push(
          `Nama Aggregator can't more than ${dataVarcharMaxLength} character`
        );
      if (!this.$v.PICName.alphanumChar)
        errors.push(`Valid character are A-z, 0-9, and (*)`);
      return errors;
    },
    aggregatorOwnerNameErrors() {
      const errors = [];
      if (!this.$v.aggregatorOwnerName.$dirty) return errors;
      if (!this.$v.aggregatorOwnerName.required)
        errors.push('Nama Pemilik Usaha is required');
      if (!this.$v.aggregatorOwnerName.maxLength)
        errors.push(
          `Nama Pemilik Usaha can't more than ${dataVarcharMaxLength} character`
        );
      if (!this.$v.aggregatorOwnerName.alphanumChar)
        errors.push(`Valid character are A-z, 0-9, and (*)`);
      return errors;
    },
    noTelpAggregatorErrors() {
      const errors = [];
      if (!this.$v.noTelpAggregator.$dirty) return errors;
      if (!this.$v.noTelpAggregator.numeric) errors.push('Must be numeric');
      if (!this.$v.noTelpAggregator.maxLength)
        errors.push("No Telephone can't more than 15 character");
      return errors;
    },
    noKTPErrors() {
      const errors = [];
      if (!this.$v.noKTP.$dirty) return errors;
      if (!this.$v.noKTP.required) errors.push('KTP number is required');
      if (!this.$v.noKTP.numeric) errors.push('Must be numeric');
      if (!this.$v.noKTP.maxLength) errors.push('KTP number must be 16 digit');
      if (!this.$v.noKTP.minLength) errors.push('KTP number must be 16 digit');
      if (!this.$v.noKTP.isUnique) {
        if (this.errorValidation.ktp_no != null) {
          this.errorValidation.ktp_no.forEach((item) => {
            errors.push(item);
          });
        }
      }
      return errors;
    },
    noKTPPICErrors() {
      const errors = [];
      if (!this.$v.noKTPPIC.$dirty) return errors;
      if (!this.$v.noKTPPIC.required) errors.push('KTP number is required');
      if (!this.$v.noKTPPIC.numeric) errors.push('Must be numeric');
      if (!this.$v.noKTPPIC.maxLength)
        errors.push('KTP number must be 16 digit');
      if (!this.$v.noKTPPIC.minLength)
        errors.push('KTP number must be 16 digit');
      if (!this.$v.noKTPPIC.isUnique) {
        if (this.errorValidation.aggre_pic_ktp_no != null) {
          this.errorValidation.aggre_pic_ktp_no.forEach((item) => {
            errors.push(item);
          });
        }
      }
      return errors;
    },
    noNPWPErrors() {
      const errors = [];
      if (!this.$v.noNPWP.$dirty) return errors;
      if (!this.$v.noNPWP.required) errors.push('NPWP number is required');
      if (!this.$v.noNPWP.numeric) errors.push('Must be numeric');
      if (!this.$v.noNPWP.maxLength)
        errors.push('NPWP harus 16 digit, pastikan Anda mengisi data dengan benar!');
      if (!this.$v.noNPWP.minLength)
        errors.push('NPWP harus 16 digit, pastikan Anda mengisi data dengan benar!');
      if (!this.$v.noNPWP.isUnique) {
        if (this.errorValidation.npwp_no != null) {
          this.errorValidation.npwp_no.forEach((item) => {
            errors.push(item);
          });
        }
      }
      return errors;
    },
    jabatanErrors() {
      const errors = [];
      if (!this.$v.jabatan.$dirty) return errors;
      if (!this.$v.jabatan.required) errors.push('Jabatan is required');
      if (!this.$v.jabatan.maxLength)
        errors.push(
          `Jabatan can't more than ${dataVarcharMaxLength} character`
        );
      if (!this.$v.jabatan.alphanumChar)
        errors.push(`Valid character are A-z, 0-9, and (*)`);
      return errors;
    },
    emailErrors() {
      const errors = [];
      if (!this.$v.email.$dirty) return errors;
      if (!this.$v.email.email || !this.$v.email.doesNotContainPipe)
        errors.push('Must be valid e-mail');
      if (!this.$v.email.required) errors.push('Email is required');
      if (!this.$v.email.isUnique) {
        if (this.errorValidation.email != null) {
          this.errorValidation.email.forEach((item) => {
            errors.push(item);
          });
        }
      }
      return errors;
    },
    emailPICErrors() {
      const errors = [];
      if (!this.$v.emailPIC.$dirty) return errors;
      if (!this.$v.emailPIC.email || !this.$v.emailPIC.doesNotContainPipe)
        errors.push('Must be valid e-mail');
      if (!this.$v.emailPIC.required) errors.push('PIC Email is required');
      if (!this.$v.emailPIC.isUnique) {
        if (this.errorValidation.aggre_pic_email != null) {
          this.errorValidation.aggre_pic_email.forEach((item) => {
            errors.push(item);
          });
        }
      }
      return errors;
    },
    noHandphoneErrors() {
      const errors = [];
      if (!this.$v.noHandphone.$dirty) return errors;
      if (!this.$v.noHandphone.required)
        errors.push('No Handphone is required');
      if (!this.$v.noHandphone.numeric) errors.push('Must be numeric');
      if (!this.$v.noHandphone.maxLength) errors.push('Max length 15 digits');
      if (!this.$v.noHandphone.isUnique) {
        if (this.errorValidation.aggre_pic_mobile_phone != null) {
          this.errorValidation.aggre_pic_mobile_phone.forEach((item) => {
            errors.push(item);
          });
        }
      }
      return errors;
    },
    endpointErrors() {
      const errors = [];
      if (!this.$v.endpoint.$dirty) return errors;
      if (!this.$v.endpoint.url) errors.push('URL not valid');
      if (!this.$v.endpoint.maxLength)
        errors.push(`URL can't more than ${dataVarcharMaxLength} character`);
      return errors;
    },
    ipaddressErrors() {
      const errors = [];
      if (!this.$v.ipaddress.$dirty) return errors;
      if (!this.$v.ipaddress.ipAddress) errors.push('IP Address not valid');
      if (!this.$v.ipaddress.maxLength)
        errors.push(`IP Address more than ${dataVarcharMaxLength} character`);
      return errors;
    },
    IDApprover1Errors() {
      const errors = [];
      if (!this.$v.IDApprover1.$dirty) return errors;
      if (!this.$v.IDApprover1.required)
        errors.push('ID Approver 1 is required');
      if (!this.$v.IDApprover1.isUnique) {
        if (this.errorValidation.approver_1 != null) {
          this.errorValidation.approver_1.forEach((item) => {
            errors.push(item);
          });
        }
      }
      return errors;
    },
    IDApprover2Errors() {
      const errors = [];
      if (!this.$v.IDApprover2.$dirty) return errors;
      if (!this.$v.IDApprover2.required)
        errors.push('ID Approver 2 is required');
      if (!this.$v.IDApprover2.isUnique) {
        if (this.errorValidation.approver_2 != null) {
          this.errorValidation.approver_2.forEach((item) => {
            errors.push(item);
          });
        }
      }
      return errors;
    },
    alamatAggregatorErrors() {
      const errors = [];
      if (!this.$v.alamatAggregator.$dirty) return errors;
      if (!this.$v.alamatAggregator.required)
        errors.push('Alamat Aggregator is required');
      if (!this.$v.alamatAggregator.maxLength)
        errors.push(
          `Alamat Aggregator can't more than ${dataVarcharMaxLength} character`
        );
      if (!this.$v.alamatAggregator.doesNotContainPipe)
        errors.push(`Character is not allowed`);
      return errors;
    },

    itemsKodepos() {
      return this.$store.state.master.daerah.list.kodepos;
    },
    itemsJenisUsaha() {
      return this.$store.state.master.daerah.list.jenisUsaha;
    },
    itemsAreaCode() {
      return this.$store.state.master.daerah.list.areaCode;
    },
    namaJenisUsaha() {
      return this.jenisUsaha == null ? '' : this.jenisUsaha.mcc_name;
    },

    namaProvinsi() {
      return this.getNamaDaerah('provinsi');
    },
    namaKabupaten() {
      return this.getNamaDaerah('kabupaten');
    },
    namaKecamatan() {
      return this.getNamaDaerah('kecamatan');
    },
    namaKelurahan() {
      return this.getNamaDaerah('kelurahan');
    },
    namaKodepos() {
      return this.getNamaDaerah('kodepos');
    },

    isLoading() {
      return this.$store.state.inputer.aggregator.loading;
    },
  },
  methods: {
    async getValidateRek(val) {
      this.isloadingRekening = true;
      this.$store
        .dispatch('inputer/aggregator/validate', {
          date,
          no_rekening: val,
        })
        .then(() => {
          this.isloadingRekening = false;
        });
    },

    getNamaDaerah(category) {
      if (this.kodepos != null) {
        let nama = '';
        const splitDaerah = this.kodepos.id.split(', ');
        const [kelurahan, kecamatan, kabupaten, provinsi, kodepos] =
          splitDaerah;
        switch (category) {
          case 'kodepos':
            nama = kodepos;
            break;
          case 'provinsi':
            nama = provinsi;
            break;
          case 'kabupaten':
            nama = kabupaten;
            break;
          case 'kecamatan':
            nama = kecamatan;
            break;
          case 'kelurahan':
            nama = kelurahan;
            break;
          default:
            break;
        }
        return nama;
      }
      return '';
    },

    async getDaerah() {
      this.isLoadingKodepos = true;
      await this.$store.dispatch('master/daerah/list/getDaerah', {
        query: this.searchKodepos == null ? '' : this.searchKodepos,
      });
      this.isLoadingKodepos = false;
    },

    async getJenisUsaha() {
      this.isLoadingJenisUsaha = true;
      await this.$store.dispatch('master/daerah/list/getJenisUsaha', {
        date,
        searchName: this.searchJenisUsaha,
      });
      this.isLoadingJenisUsaha = false;
    },

    async getAreaCode() {
      this.isLoadingAreaCode = true;
      await this.$store.dispatch('master/daerah/list/getAreaCode', {
        date,
        query: this.searchAreaCode,
      });
      this.isLoadingAreaCode = false;
    },


    async getApprovalId1(role) {
      this.isLoadingApprovalId1 = true;
      await this.$store
        .dispatch('master/daerah/list/getApprovalId1', {
          date,
          role,
          kodepos: this.namaKodepos,
          search: {
            username: this.searchApprovalId1,
          },
        })
        .finally(() => {
          this.isLoadingApprovalId1 = false;
        });
    },

    async getApprovalId2(role) {
      this.isLoadingApprovalId2 = true;
      await this.$store
        .dispatch('master/daerah/list/getApprovalId2', {
          date,
          role,
          kodepos: this.namaKodepos,
          search: {
            username: this.searchApprovalId2,
          },
        })
        .finally(() => {
          this.isLoadingApprovalId2 = false;
        });
    },

    async save() {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        const allData = {
          pic_name: this.PICName,
          pic_ktp_no: this.noKTPPIC,
          pic_jabatan: this.jabatan,
          pic_mobile_phone: this.noHandphone,
          pic_email: this.emailPIC,
          aggre_company_name: this.companyName,
          aggre_owner_name: this.aggregatorOwnerName,
          aggre_ktp_no: this.noKTP,
          aggre_npwp_no: this.noNPWP,
          aggre_address: this.alamatAggregator,
          aggre_email: this.email,
          aggre_phone: this.noTelpAggregator,
          aggre_phone_area_code: this.areaCode,
          province_name: this.namaProvinsi,
          city_name: this.namaKabupaten,
          sub_district_name: this.namaKecamatan,
          urban_name: this.namaKelurahan,
          postal_code: this.namaKodepos,
          bcko: this.bcko ? (this.bcko.id || this.bcko.branch_code_bcko || '') : '',
          cmer: this.cmer ? (this.cmer.id || this.cmer.code || '') : '',
          referral_code: this.rmReferalCode,
          phone_area_code: this.areaCode,
          approver_1: this.IDApprover1.user_id,
          approver_2: this.IDApprover2.user_id,
          no_rekening: this.noRekening,
          endpoint: this.endpoint,
          ip_address: this.ipaddress,
          qr_type: this.qrType,
          notif_sticker_status: this.stickerApiType
            ? this.submerchantNotif
            : '0',
        };

        await this.$store
          .dispatch('inputer/aggregator/createAggregator', {
            date,
            payload: allData,
          })
          .then((response) => {
            if (response) {
              this.$router.push('/inputer/aggregator');
            } else if (this.hasFieldErrors) {
              this.scrollToErrorInput();
            }
          });
      } else {
        this.scrollToErrorInput();
      }
    },

    scrollToErrorInput() {
      const keys = Object.keys(this.$v);
      let isError = false;

      keys.forEach((key) => {
        const input = key;

        if (input.includes('$')) return;

        if (this.$v[input].$error) {
          this.$vuetify.goTo(`#${input}`, scrollOptions);
          isError = true;
        }
      });

      if (!isError) this.$vuetify.goTo(0);
    },

    back() {
      this.$router.back();
    },
  },
};
</script>
